<template>
  <li class="flex-space-between panel-block">
    <div class="input-container">
      <a v-if="!editing" :href="url" :target="id">
        {{ title }}
      </a>
      <input
        type='text'
        :value="title"
        v-if="editing"
        class="input"
        ref="resource"
        />
    </div>

    <div>

      <input
        @click="editing = true"
        v-if="!editing"
        type='button'
        class='button is-small'
        value='edit'
        name='edit'/>

      <input
        @click="showModal()"
        v-if="editing"
        type='button'
        class='button is-small is-danger'
        value='delete'
        name='delete'/>

      <button
        @click="update()"
        v-if="editing"
        type='button'
        class='button is-small'
        :class="updating && 'is-loading'"
        name='save'>
        save
      </button>

      <input
        @click="editing = false"
        v-if="editing"
        type='button'
        class='button is-small'
        value='cancel'
        name='cancel'/>

    </div>

    <Confirm
      @cancel="show = false"
      @confirm="remove()"
      :loading="deleting"
      title="Deleting Resource"
      message="Are you sure you want to delete the resource?"
      :show="show"
    />

  </li>
</template>

<script>
import store from '../store.js'
import Confirm from './Confirm.vue'

export default {
  name: 'Resource',
  props: {
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    cycleID: {
      type: Number,
      required: false,
    },
    videoID: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      editing: false,
      updating: false,
      deleting: false,
      show: false,
    }
  },
  components: {
    Confirm,
  },
  methods: {
    showModal () {
      this.show = !this.show
    },
    remove () {
      const { cycleID, videoID, id } = this
      this.deleting = true
      store.dispatch('deleteResource', { cycleID, videoID, resourceID: id })
        .then(() => {
          this.deleting = false
        })
    },
    update () {
      const { cycleID, videoID, id } = this
      const newTitle = this.$refs.resource.value
      this.updating = true
      store.dispatch('updateResource', { cycleID, videoID, resourceID: id, newTitle })
        .then(() => {
          this.editing = false
          this.updating = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.input-container {
  flex-grow: 1;
  margin-right: 1rem;
}
</style>



// WEBPACK FOOTER //
// Resource.vue?a5949a98